import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {IonicModule} from '@ionic/angular';
import {CompanyEmployeeComponent} from './company-employee.component';
import {FormsModule} from '@angular/forms';
import {ActionPointListModule} from '../action-point-list/action-point-list.module';


@NgModule({
  declarations: [CompanyEmployeeComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    ActionPointListModule
  ],
  exports: [CompanyEmployeeComponent]
})
export class CompanyEmployeeModule {
}
